
import Field from 'Shared/components/Settings/Field'
import QuestionIcon from 'CampaignBuilder/components/QuestionIcon'
import './SettingsSchemaForm.scoped.scss'

export default function SettingsSchemaForm({ settings, config, onChange }) {
  const settingsMode = settings.settingsMode

  useEffect(() => {
    if(settingsMode === 'default') {
      setDefaults()
    }
  }, [settingsMode])

  function setDefaults() {
    _.each(config, (setting, key) => {
      if (setting.kind === 'time_range' || setting.kind === 'duration_range') {
        onChange(setting.keys[0], setting.default[0]);
        onChange(setting.keys[1], setting.default[1]);
      } else if (setting.kind === 'multi_checkbox') {
        setting.options.forEach((v) => {
          if (v.default) {
            onChange(v.value, 'true')
          } else {
            onChange(v.value, 'false')
          }
        })
      } else {
        onChange(key, setting.default)
      }
    })
  }

  function settingValues(key, settingConfig) {
    const kind = settingConfig.kind

    if (kind === 'time_range' || kind === 'duration_range') {
      const keys = settingConfig.keys
      return keys.map(key => settings[key])
    } else if (kind === 'multi_checkbox') {
      const keys = settingConfig.options?.map(o => o.value)
      return keys.map(key => settings[key])
    } else {
      return settings[key]
    }
  }

  function updateValue(setting, key, value) {
    onChange('settingsMode', 'custom')
    if (setting.kind === 'time_range' || setting.kind === 'duration_range') {
      onChange(setting.keys[0], value[0]);
      onChange(setting.keys[1], value[1]);
    } else if (setting.kind === 'multi_checkbox') {
      onChange(value.key, value.value);
    } else {
      onChange(key, value);
    }
  }

  const customConfig = _.omitBy(config, (setting, key) => setting.dependsOn && !_.every(setting.dependsOn, (value, key) => _.includes(settings[key], value)))
  const customConfigAsArray = _.map(customConfig, (setting, key) => ({ key, ...setting }))
  const groupedConfig = _.groupBy(customConfigAsArray, row => row.section || 'Other')

  return (
    <div>
      <fieldset>
        { _.map(groupedConfig, (settingsGroup, section) => <>
          { _.keys(groupedConfig).length > 1 && <h3 key={section}><strong>{section}</strong></h3> }

          {_.map(settingsGroup, (setting) => {
            const { key } = setting
            if (setting.hidden) return null

            return <div className="field" key={key}>
              <label>{setting.label}</label>
              <div className="input">
                <Field
                  value={settingValues(key, setting)}
                  onChange={v => updateValue(setting, key, v)}
                  setting={setting}
                />
              </div>
              {setting.description ?
                <div className="description">
                  <QuestionIcon /><span>{setting.description}</span>
                </div> : null
              }
            </div>
          })}
        </>)}
        <p><a className="link" onClick={() => onChange('settingsMode', 'default')}>Reset to default</a></p>
      </fieldset>
    </div>
  )
}
